<ef-loading
    [loading]="IsLoading"
></ef-loading>

<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="col xl:col-12 lg:col-12 md:col-12 sm:col-12 xs:col-12 p-2">
    <div class="shadow-2 surface-card border-round p-4 h-full">
        <div class="flex align-items-start mb-5">
            <div class="ml-3">
                <span class="block text-900 mb-1 text-xl font-medium">Send Expenses</span>
                <p-message
                    severity="info"
                    text='Send approved expense reports to QuickBooks for the set period and selected users. To re-send expense reports, check the box to refresh the user list, select users and click Resend. IMPORTANT: Delete the original expense report bill and optionally credit card charges before resending an expense report.'
                ></p-message>
            </div>
        </div>
        <div class="ml-3">
            <ef-send-purchases-filter
                (Filter)="onFilter($event)"
                [startDate]="(userInfo$ | async)?.PrevPayPeriodStart"
                [endDate]="(userInfo$ | async)?.PrevPayPeriodEnd"
            ></ef-send-purchases-filter>

            <p-messages></p-messages>

            <ef-send-purchases-presenter
                [resend]="resend$ | async"
                [items]="items$ | async"
                (SendPurchases)="onSendPurchases($event)"
            ></ef-send-purchases-presenter>
        </div>
    </div>
</div>
<!-- <ef-send-purchases-filter
    (Filter)="onFilter($event)"
    [startDate]="(userInfo$ | async)?.PrevPayPeriodStart"
    [endDate]="(userInfo$ | async)?.PrevPayPeriodEnd"
></ef-send-purchases-filter>
<p-messages></p-messages>
<ef-send-purchases-presenter
    [items]="items$ | async"
    (SendPurchases)="onSendPurchases($event)"
></ef-send-purchases-presenter> -->
